import React, {
    FormEvent,
    ReactElement, useEffect, useState,
} from "react";
import { Form } from "react-bootstrap";
import TagList from "../../../../../components/tag-list/TagList";
import TimedMessage from "../../../../../components/timed-message/TimedMessage";
import WorkflowPicker from "../../../../../components/workflow/WorkflowPicker";
import { GetChannelTagsDocument, GetSettingsDocument, useSaveSettingsMutation } from "../../../../../__generated__/api";
import { SettingsProps } from "../../base";

export default function ChannelTagSettings(props: SettingsProps): ReactElement {
    const [save] = useSaveSettingsMutation();

    const [channelTags, setChannelTags] = useState(() => props.settings?.channels?.channelTags);
    const [isSaved, setIsSaved] = useState(false);

    useEffect(() => {
        setChannelTags(props.settings?.channels?.channelTags);
    }, [props.settings]);

    const onSubmit = (event: FormEvent) => {
        event.preventDefault();
        (async () => {
            await save({
                refetchQueries: [
                    { query: GetChannelTagsDocument },
                    { query: GetSettingsDocument },
                ],
                variables: {
                    channels: {
                        channelTags,
                    },
                },
            });
            setIsSaved(true);
        })();
    };

    return (
        <form className="flex-grow-1" onSubmit={onSubmit}>

            <div className="border p-3 rounded mb-5 bg-white">
                <TimedMessage shouldShow={isSaved} onClose={() => setIsSaved(false)}>
                    Channel settings saved
                </TimedMessage>
                <h5 className="mb-3 text-light">
                    General Channel Settings
                </h5>

                <Form.Group className="mb-3">
                    <Form.Label className="fw-bolder">Channel Tags</Form.Label>
                    <TagList
                        value={channelTags as string[] ?? []}
                        onChange={value => setChannelTags(value)}
                        isTag
                        canNotHaveDuplicates
                        shouldSort
                    />
                    <Form.Text>
                        Different types of channels can be assigned tags. Tags are a way to group a set of
                        channels together for sending mass messages or using queues.
                    </Form.Text>
                </Form.Group>

            </div>

            {channelTags?.isNotEmpty && (
                <div className="border p-3 rounded mb-5 bg-white">

                    <h5 className="mb-3 text-light">
                        Automations
                    </h5>

                    <div className="list-group">
                        {channelTags?.sortBy(tag => tag).map(tag => (
                            <div
                                key={tag}
                                className={"list-group-item list-group-item-action "
                        + "d-flex align-items-center d-flex justify-content-between"}
                            >
                                <div className="flex-grow-1">
                                    <h5 className="mb-0">
                                        <code>
                                            #
                                            {tag}
                                        </code>
                                    </h5>
                                </div>
                                <div className="d-flex flex-grow-0 align-items-end">
                                    <WorkflowPicker
                                        buttonClassName="text-light"
                                        referenceId={`urn:fq:channel-tag:${tag}`}
                                        title={`Tag Automation: ${tag}`}
                                        buttonText="Automations"
                                    />
                                </div>

                            </div>

                        ))}

                    </div>

                </div>
            )}

            <div className="d-flex justify-content-end mt-3 fixed-bottom border-top p-3 bg-white">
                <button type="submit" className="btn btn-primary">
                    Save
                </button>
            </div>

        </form>
    );
}
